<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Summary</h2>
    </v-flex>
    <v-flex
      sm6 xs12
      :class="{'pr-0 pb-4 mt-3': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp}">
      <v-text-field @keyup="$emit('bucket-update')" box label="Title" v-model="bucket.name"></v-text-field>
      <v-textarea
        @keyup="$emit('bucket-update')"
        box label="Description"
        v-model="bucket.description">
      </v-textarea>
    </v-flex>
    <v-flex xs12>
      <h3 class="primary--text pt-3">Show User Presence</h3>
      <v-switch
        class="mt-1"
        color="secondary"
        v-model="bucket.showUserPresence"
        label="Turn on user presence">
      </v-switch>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    presenceSwitch: true
  }),
  props: { bucket: { type: Object, required: true } }
}
</script>
